import { Component, OnDestroy, OnInit } from '@angular/core';
import { ImageSliderComponent } from "../../component/image-slider/image-slider.component";
import { NgForOf, NgIf } from "@angular/common";
import { CommonComponent } from "../../common/common-component";
import { interval, merge, mergeMap, Subscription, tap, timer } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../../common/service/config.service";
import { environment } from "../../../environments/environment";
import { ContentBlockComponent } from "../../component/content-block/content-block.component";
import { NotificationService } from "../../common/service/notification.service";

@Component({
  selector: 'section#gallery5.gallery',
  standalone: true,
  imports: [
    ImageSliderComponent,
    NgForOf,
    NgIf,
    ContentBlockComponent
  ],
  templateUrl: './gallery5.component.html'
})
export class Gallery5Component extends CommonComponent implements OnInit, OnDestroy {

  private subscription: Subscription | undefined;
  private wsSubscription: Subscription | undefined;
  protected override limit = 12;

  constructor(
    private httpClient: HttpClient,
    private notificationService: NotificationService,
    private configService: ConfigService
  ) {
    super();
  }

  ngOnInit(): void {

    this.subscription =  this.configService.config$.pipe(
      tap(config => this.config = config),
      mergeMap(() => merge(timer(50), interval(30000))),
      mergeMap(() => this.httpClient.post<Array<{assets: Array<any>, id: string, createdAt: Date, status: string}>>(environment.api_v2_url + '/gallery?limit=' + this.limit, { event_ids: [this.config.id] })),
    ).subscribe((items: Array<{assets: Array<any>, id: string, createdAt: Date, status: string}>) => {
      this.populateGallery(items);
      this.wsSubscription = this.notificationService.connect(this.config.id).asObservable().subscribe(() => {
        window.location.reload();
      });
    });
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
